define('service/external.org.adder.service',['require','exports','module','underscore','marionette','backbone.radio','uikit/uikit','blockit','view/finder/external.org.adder.view','model/provisional.organization.model'],function(require, exports, module) {
  //prettier-ignore
  var _                            = require('underscore'),
      Mn                           = require('marionette'),
      Radio                        = require('backbone.radio'),
      UIKit                        = require('uikit/uikit'),
      BlocKit                      = require('blockit'),
      ExternalOrgAdderView         = require('view/finder/external.org.adder.view'),
      ProvisionalOrganizationModel = require('model/provisional.organization.model');

  var ExternalOrgAdderService = {
    radioRequests: {
      'externalOrgAdderService open': 'open',
    },

    open: function(options) {
      var options = options || {};

      options.model = new ProvisionalOrganizationModel({ provisioned: true });

      var ExternalOrgAdderModal = UIKit.Modal2.extend({
        options: _.extend({}, UIKit.Modal2.prototype.options, {
          closable: true,
          closeIcon: false,
          size: '',
        }),

        initialize: function() {
          UIKit.Modal2.prototype.initialize.apply(this, arguments);
          this.listenTo(this.contentView.nameView, 'change', function(child, field, newVal, oldVal) {
            if (newVal || oldVal) {
              this.contentView.nameView.validate();
              this.actionsView.render();
            }
          });
        },

        internalViewOptions: {
          headerView: function() {
            return {
              type: UIKit.Header.extend({
                tagName: 'div',
                ariaLevel: '2',
                className: 'header',
              }),
              text: 'Request New External Organization',
            };
          },
          contentView: function() {
            return _.extend({}, options, {
              type: ExternalOrgAdderView,
            });
          },
          actionsView: function() {
            var contentView = this.contentView;
            return {
              type: UIKit.ComponentsContainerView.extend({
                className: 'actions',
                childView: UIKit.Button,
                components: [
                  {
                    type: UIKit.Modal2.ModalDenyButtonView,
                    name: 'denyButton',
                    text: 'Cancel',
                    color: 'basic',
                    onPress: function() {
                      Radio.channel('finderService').request('open', 'ExternalOrg', options.finderOptions);
                    },
                  },
                  {
                    type: UIKit.Button,
                    text: 'Save',
                    color: 'primary',
                    onPress: function() {
                      contentView.clearErrors();
                      options.model.save(
                        {},
                        {
                          error: function(model, response) {
                            if (response.xhr && response.xhr.responseJSON && response.xhr.responseJSON.errors) {
                              var errors = response.xhr.responseJSON.errors;
                              for (var i = 0; i < errors.length; i++) {
                                contentView.addError(errors[i].message);
                              }
                            } else {
                              contentView.addError(
                                'An error occurred when communicating with the server. Please try again.'
                              );
                            }
                          },
                          success: function(model) {
                            Radio.channel('finderService').request(
                              'open',
                              'ExternalOrg',
                              _.extend(options.finderOptions, {
                                newModel: model,
                              })
                            );
                          },
                        }
                      );
                      return false;
                    },
                    behaviors: {
                      BindAndFormatOptionValuesBehavior: {
                        optionValues: {
                          disabled: {
                            formatter: function() {
                              return !contentView.nameView.isValid();
                            },
                          },
                        },
                        behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                      },
                    },
                  },
                ],
              }),
            };
          },
        },
      });

      var adderModal = new ExternalOrgAdderModal();

      _.defer(function() {
        adderModal.visible = true;
        adderModal.contentView.clearErrors();
      });

      return adderModal;
    },
  };

  module.exports = ExternalOrgAdderService;
});

